<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref, watch} from "vue";
import {useSecurityStore} from "@/stores/Security";
import {storeToRefs} from "pinia";
import {useControlProgramStore} from "@/views/Notification/stores/ControlProgram";
import axios from "axios";

export default {
    name: "WControlProgramAutocomplete",
    props: {
        value: Array,
        module: {
            type: String,
            required: true,
        },
        label: String,
        rules: Array,
        readonly: Boolean,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        
        const programs = ref([]);
        const program = ref(null);
        
        const controlProgramStore = useControlProgramStore();
        
        const securityStore = useSecurityStore();
        
        const {idControlProgram} = storeToRefs(securityStore);
        
        watch(() => idControlProgram.value, () => {
            if (idControlProgram.value) {
                program.value = idControlProgram.value;
                emit('input', program ? [program.value] : []);
            } else {
                program.value = null;
                emit('input', null);
            }
        });
        
        function findAll() {
            loading.value = true;
            axios.get(`controlPrograms/filter/${props.module}`).then(response => {
                controlProgramStore.setControlPrograms(response.data);
            }).finally(() => {
                loading.value = false;
            })
        }
        
        function change() {
            emit('input', program.value ? [program.value] : [])
            idControlProgram.value = program.value;
        }
        
        watch(() => props.value, () => {
            if (props.value && props.value.length > 0)
                program.value = props.value[0];
        }, {immediate: true});
        
        onMounted(() => findAll());
        
        return {
            securityStore,
            programs,
            program,
            controlProgramStore,
            loading,
            inputColor,
            backgroundColor,
            change
        }
    },
}
</script>

<template>
    <div>
        <v-autocomplete
            v-if="securityStore.authorities.READ_NOTIFICATION_PARAM"
            v-model="program"
            :items="controlProgramStore.controlPrograms"
            item-value="id"
            item-text="name"
            :label="label"
            outlined
            dense
            clearable
            :loading="loading"
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details="auto"
            :rules="rules"
            @change="change"
            @click:clear="$emit('input', [])"
        ></v-autocomplete>
        
        <input type="hidden"/>
    </div>
</template>

<style scoped>

</style>